const SCROLL_PADDING_PX = 16;
const SCROLL_PADDING_VAR = '--registration-sticky-progression-scroll-padding';
const CORRECTION_DELAYS_MS = [0, 120, 350, 700];

const getScrollTarget = (invalidControl) => invalidControl.closest('[data-js-sign-off-controls]')
  || invalidControl.closest('.advanced-choice--terms')
  || invalidControl.closest('.advanced-choice')
  || invalidControl.closest('.form-group')
  || invalidControl;

const isRegistrationReskin = () => {
  const { body } = document;

  return body.classList.contains('reg-checkout-reskin')
    && body.classList.contains('event-registration-shell')
    && !body.classList.contains('kiosk-registration');
};

const getStickyBarTop = () => {
  let top = window.innerHeight;

  document.querySelectorAll('[data-js-sticky-progression]').forEach((bar) => {
    const { height, top: barTop } = bar.getBoundingClientRect();

    if (height > 0) {
      top = Math.min(top, barTop);
    }
  });

  return top;
};

const getStickyBottomInset = () => {
  const barTop = getStickyBarTop();

  if (barTop >= window.innerHeight) {
    return 0;
  }

  return Math.max(0, window.innerHeight - barTop) + SCROLL_PADDING_PX;
};

const applyScrollPadding = (bottomInset) => {
  if (bottomInset <= SCROLL_PADDING_PX) {
    return;
  }

  document.documentElement.style.setProperty(SCROLL_PADDING_VAR, `${bottomInset}px`);
  document.documentElement.style.scrollPaddingBottom = `${bottomInset}px`;
};

const getScrollOverflow = (scrollTarget) => {
  const barTop = getStickyBarTop();
  const rect = scrollTarget.getBoundingClientRect();
  const bottomOverflow = rect.bottom - (barTop - SCROLL_PADDING_PX);
  const topOverflow = SCROLL_PADDING_PX - rect.top;

  return { bottomOverflow, topOverflow };
};

const ensureMainScrollRoom = (extraPx) => {
  const main = document.querySelector('main');

  if (!main || extraPx <= 0) {
    return;
  }

  const currentExtra = Number(main.dataset.waiverScrollPadExtra || 0);

  if (extraPx <= currentExtra) {
    return;
  }

  main.dataset.waiverScrollPadExtra = String(Math.ceil(extraPx));
  const basePadding = Number.parseFloat(getComputedStyle(main).paddingBottom) || 0;
  main.style.paddingBottom = `${basePadding + extraPx - currentExtra}px`;
};

const nudgeScrollForClearance = (scrollTarget) => {
  const { bottomOverflow, topOverflow } = getScrollOverflow(scrollTarget);

  if (bottomOverflow > 1) {
    const maxScrollY = Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight,
    );

    if (window.scrollY >= maxScrollY - 1) {
      ensureMainScrollRoom(bottomOverflow);
    }

    window.scrollBy({ top: bottomOverflow, behavior: 'auto' });
    return true;
  }

  if (topOverflow > 1) {
    window.scrollBy({ top: -topOverflow, behavior: 'auto' });
    return true;
  }

  return false;
};

const runScrollCorrections = (scrollTarget) => {
  const bottomInset = getStickyBottomInset();
  applyScrollPadding(bottomInset);

  if (bottomInset > SCROLL_PADDING_PX) {
    scrollTarget.style.scrollMarginBottom = `${bottomInset}px`;
  }

  CORRECTION_DELAYS_MS.forEach((delay) => {
    window.setTimeout(() => {
      for (let attempt = 0; attempt < 4; attempt += 1) {
        if (!nudgeScrollForClearance(scrollTarget)) {
          break;
        }
      }
    }, delay);
  });
};

const scrollWithStickyClearance = (scrollTarget) => {
  const bottomInset = getStickyBottomInset();

  if (bottomInset <= SCROLL_PADDING_PX) {
    scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    return;
  }

  applyScrollPadding(bottomInset);
  scrollTarget.style.scrollMarginBottom = `${bottomInset}px`;

  scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  runScrollCorrections(scrollTarget);
};

const scrollInvalidControlIntoView = (invalidControl) => {
  if (!invalidControl || !(invalidControl instanceof Element)) {
    return;
  }

  const scrollTarget = getScrollTarget(invalidControl);

  if (!isRegistrationReskin()) {
    scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    return;
  }

  scrollWithStickyClearance(scrollTarget);
};

export default scrollInvalidControlIntoView;
